import { APP_BUNDLES } from '../../app_constant';
import { GET_LOCAL_QUESTIONS, GET_FLASHCARDS, GET_ARTICLES, GET_GLOSSARY, GET_ACRONYMS } from '../api/content';

/**
 * Returns an array of exam details for all available exams.
 * Each object contains:
 *   - key: exam key (e.g., 'cisa')
 *   - name: exam name/title (e.g., 'CISA')
 *   - numQuestions: number of questions for the exam
 *   - numFlashcards: number of flashcards for the exam
 *   - numArticles: number of articles for the exam
 *   - numGlossary: number of glossary terms for the exam
 *   - numAcronyms: number of acronyms for the exam
 */
export function getExamDetails() {
  return APP_BUNDLES.map((bundle) => {
    const key = bundle.key;
    const name = bundle.title;
    const description = bundle.description;
    const numQuestions = GET_LOCAL_QUESTIONS(key)?.length || 0;
    const numFlashcards = GET_FLASHCARDS(key)?.length || 0;
    const numArticles = GET_ARTICLES(key)?.length || 0;
    const numGlossary = GET_GLOSSARY(key)?.length || 0;
    const numAcronyms = GET_ACRONYMS(key)?.length || 0;
    
    return {
      key,
      name,
      description,
      numQuestions,
      numFlashcards,
      numArticles,
      numGlossary,
      numAcronyms,
    };
  });
} 